import service from "@/store/services/auctions-service";

export const state = () => ({
  list: {},
  auction: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, auction) => {
    state.auction = auction;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((auction) => {
      commit("SET_RESOURCE", auction);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((auction) => {
      commit("SET_RESOURCE", auction);
    });
  },

  reload({ commit, dispatch }, params) {
    return service.reload(params, this.$axios).then((auction) => {
      commit("SET_RESOURCE", auction);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((auction) => {
      commit("SET_RESOURCE", auction);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
  extractAuctionDetails({ commit, dispatch }, params) {
    return service.extractAuctionDetails(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  auction: (state) => state.auction,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((auction) => ({
      id: auction.id,
      name: `${auction.firstname} ${auction.lastname}`,
    }));
  },
};

const auctions = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default auctions;
